<template>
  <main class="Page-styles-page Page-styles-desktop">
    <div class="SidebarLayout-styles-layout MyAccountWrapper-styles-layout">
      <div class="SidebarLayout-styles-sidebar MyAccountWrapper-styles-sidebar">
        <div class="">
          <div class="BalanceBox-styles-elements">
            <div class="Paper-styles-paper Card-styles-paper BalanceBox-styles-account-balance-card BalanceBox-styles-desktop">
              <div class="Card-styles-card">
                <div class="CollapsibleItem-styles-collapsible-item BalanceBox-styles-collapsible-item">
                  <div class="BalanceBox-styles-balance-header">
                    <div class="BalanceBox-styles-header-card Card-styles-content">
                      <div class="BalanceBox-styles-balance-header-container">
                        <div id="accountBalance" class="BalanceBox-styles-balance-container">
                          <div class="BalanceBox-styles-balance-label"></div>
                          <div class="BalanceBox-styles-balance-amount BalanceBox-styles-desktop" @click="openMenu()">
                            {{ session.balance | toMoney(session.currency) }}
                            <div :class="(!menuOpened) ? 'BalanceBox-styles-arrow-down' : 'BalanceBox-styles-arrow-up'"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="(!menuOpened) ? 'CollapsibleItem-styles-closed' : ''">
                    <div class="BalanceBox-styles-card-content BalanceBox-styles-desktop Card-styles-content Card-styles-inset">
                      <ul class="BalanceBox-styles-collapsible-container">
                        <li>
                          <span class="BalanceBox-styles-additional-details-label">{{ t.withdrawable }}</span>
                          <span>{{ session.balance | toMoney(session.currency) }}</span>
                        </li>
                        <li>
                          <div class="BalanceBox-styles-item">
                            <span class="BalanceBox-styles-additional-details-label">Bonus</span>
                            <div class="Tooltip-styles-tooltip Tooltip-styles-placement-bottom BalanceBox-styles-tooltip">
                              <div class="Tooltip-styles-container">
                                <img src="/static/assets/img/question-mark.svg">
                              </div>
                            </div>
                          </div>
                          <span>{{ session.bonus | toMoney(session.currency) }}</span>
                        </li>
                        <li>
                          <div class="BalanceBox-styles-item">
                            <span class="BalanceBox-styles-additional-details-label">Deposit wagering</span>
                            <div class="Tooltip-styles-tooltip Tooltip-styles-placement-bottom BalanceBox-styles-tooltip">
                              <div class="Tooltip-styles-container">
                                <img src="/static/assets/img/question-mark.svg">
                              </div>
                            </div>
                          </div>
                          <span>0.00</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="BalanceBox-styles-button-wrapper">
                  <router-link :to="{name: 'error_payment_reseller'}">
                    <button id="navigateToDeposit" class="Button-styles-button Button-styles-primary Button-styles-confirmation BalanceBox-styles-button BalanceBox-styles-desktop">
                      <div class="">{{ t.deposit_now }}</div>
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <section class="MyAccountWrapper-styles-section-element">
            <section class="NavBox-styles-nav-box">
              <ul class="NavBox-styles-no-shadow NavBox-styles-no-bottom-border">
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <router-link :to="{name: 'personal_informations'}" :class="($route.name === 'personal_informations') ? 'MyAccountWrapper-styles-active-item' : ''" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item" id="navboxitem-personal-details">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/personal_details.svg">
                    <div class="NavBoxItem-styles-label-cell" id="personal-details">
                    <span>
                      <p class="NavBoxItem-styles-label-info">{{ t.navigation.personal_informations }}</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </router-link>
                </li>
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <router-link :class="($route.name === 'deposit_transactions') ? 'MyAccountWrapper-styles-active-item' : ''" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item" id="navboxitem-statement" :to="{name: 'deposit_transactions'}">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/transactions.svg">
                    <div class="NavBoxItem-styles-label-cell" id="statement">
                    <span>
                      <p class="NavBoxItem-styles-label-info">{{ t.navigation.transactions }}</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </router-link>
                </li>
                <!--
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <a class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item" id="navboxitem-limits-and-closure" href="/tr/account/limits-and-closure">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/limits.svg">
                    <div class="NavBoxItem-styles-label-cell" id="limits-and-closure">
                    <span>
                      <p class="NavBoxItem-styles-label-info">Sınırlar ve Kapanış</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </a>
                </li> !-->
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <router-link :class="($route.name === 'limit_history') ? 'MyAccountWrapper-styles-active-item' : ''" :to="{name: 'limit_history'}" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item" id="navboxitem-limits-history">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/limits_history.svg">
                    <div class="NavBoxItem-styles-label-cell" id="limits-history">
                    <span>
                      <p class="NavBoxItem-styles-label-info">{{ t.limit_history }}</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </router-link>
                </li>
              </ul>
            </section>
          </section>
          <section class="MyAccountWrapper-styles-section-element">
            <section class="NavBox-styles-nav-box">
              <ul class="NavBox-styles-no-shadow NavBox-styles-no-bottom-border">
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <a href="javascript:;" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item" id="navboxitem-balance-details">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/balances.svg">
                    <div class="NavBoxItem-styles-label-cell" id="balance-details">
                    <span>
                      <p class="NavBoxItem-styles-label-info">{{ t.navigation.balance }}</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </a>
                </li>
                <!--
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <a class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item" id="navboxitem-bonus-details" href="/tr/account/bonus-details">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/bonus.svg">
                    <div class="NavBoxItem-styles-label-cell" id="bonus-details">
                    <span>
                      <p class="NavBoxItem-styles-label-info">Bonus ayrıntıları</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </a>
                </li>
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <a id="navboxitem-payout" href="https://payment.tipico.de/tr/payout?command=withdrawal&amp;origin=app-tipico-sports" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/withdrawals.svg">
                    <div class="NavBoxItem-styles-label-cell" id="payout">
                    <span>
                      <p class="NavBoxItem-styles-label-info">{{ t.withdraw_now }}</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </a>
                </li> !-->
              </ul>
            </section>
          </section>
          <section class="MyAccountWrapper-styles-section-element">
            <router-link :class="($route.name === 'settings') ? 'MyAccountWrapper-styles-active-item' : ''" :to="{name: 'settings'}" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item" id="navboxitem-settings">
              <img class="NavBoxItem-styles-icon" src="/static/assets/img/settings.svg">
              <div class="NavBoxItem-styles-label-cell" id="settings">
              <span>
                <p class="NavBoxItem-styles-label-info">{{ t.navigation.prefences }}</p>
              </span>
              </div>
              <div class="NavBoxItem-styles-arrow-icon-cell"></div>
            </router-link>
            <span class="" id="contact">
              <a aria-current="page" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item active" id="navboxitem-contact" href="javascript:;">
                <img class="NavBoxItem-styles-icon" src="/static/assets/img/contact.svg">
                <div class="NavBoxItem-styles-label-cell" id="contact">
                  <span>
                    <p class="NavBoxItem-styles-label-info"> {{ t.contact }} </p>
                  </span>
                </div>
                <div class="NavBoxItem-styles-arrow-icon-cell"></div>
              </a>
            </span>

          </section>
          <section class="MyAccountWrapper-styles-section-element">
            <section class="NavBox-styles-nav-box">
              <ul class="NavBox-styles-no-shadow NavBox-styles-no-bottom-border">
                <li class="NavBox-styles-columns-one NavBox-styles-no-bottom-border">
                  <a @click="logout()" id="navboxitem-logout" href="javascript:;" class="NavBoxItem-styles-nav-box-item MyAccountWrapper-styles-nav-item">
                    <img class="NavBoxItem-styles-icon" src="/static/assets/img/logout.svg">
                    <div class="NavBoxItem-styles-label-cell" id="logout">
                    <span>
                      <p class="NavBoxItem-styles-label-info"> {{ t.logout }}</p>
                    </span>
                    </div>
                    <div class="NavBoxItem-styles-arrow-icon-cell"></div>
                  </a>
                </li>
              </ul>
            </section>
          </section>
          <p class="MyAccountWrapper-styles-app-version">V 3.23.100 m04</p>
        </div>
      </div>
      <div class="SidebarLayout-styles-desktop">
        <div class="SidebarLayout-styles-sidebar-wrapper">
          <router-view></router-view>
        </div>


      </div>
    </div>
  </main>

</template>

<script>
import AccountWidgets from "./accountWidgets";

export default {
  name: 'account',
  components: {AccountWidgets},
  data() {
    return {
      session: this.$root.session,
      menuOpened: false,
      t: this.$root.t
    }
  },
  methods: {
    openMenu () {
      this.menuOpened = (this.menuOpened) ? false : true;
    }
  },
  beforeDestroy() {
    var el = document.getElementById('accountCSS');
    el.remove();
  },
  mounted() {

   if( this.session.uid == 0)
    this.$router.push({name: 'Login'})

    var cssId = 'accountCSS';  // you could encode the css path itself to generate id..
    if (!document.getElementById(cssId))
    {
      var head  = document.getElementsByTagName('head')[0];
      var link  = document.createElement('link');
      link.id   = cssId;
      link.rel  = 'stylesheet';
      link.type = 'text/css';
      link.href = 'static/assets/css/account.css';
      link.media = 'all';
      head.appendChild(link);
    }
  }
}
</script>

<style>
.account-left-container {
  flex: 0 0 65%;
  float: left;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/account/home.vue